// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__4MeG4","vLegacy":"SelectSecondary_vLegacy__1pnkj","error":"SelectSecondary_error__Ontzc","disabled":"SelectSecondary_disabled__2_Gvl"};